import type { BuildingAdministrative } from '@popety-io/types'

/**
 * Get all administrative entries, sorted by most recent heating system update first
 */
export function getAdministrativeEntriesSorted(
  administrativeEntries?: BuildingAdministrative[]
): BuildingAdministrative[] {
  if (!administrativeEntries?.length) return []

  return [...administrativeEntries].sort((a, b) => {
    const dateA = a.last_update_timestamp_heater
      ? new Date(a.last_update_timestamp_heater).getTime()
      : 0
    const dateB = b.last_update_timestamp_heater
      ? new Date(b.last_update_timestamp_heater).getTime()
      : 0
    return dateB - dateA // Most recent first
  })
}

/**
 * Get the most recent administrative entry based on heating system update
 */
export function getMostRecentAdministrativeEntry(
  administrativeEntries?: BuildingAdministrative[]
): BuildingAdministrative | null {
  const sorted = getAdministrativeEntriesSorted(administrativeEntries)
  return sorted[0] || null
}

/**
 * Check if there are multiple administrative entries
 */
export function hasMultipleAdministrativeEntries(
  administrativeEntries?: BuildingAdministrative[]
): boolean {
  return (administrativeEntries?.length || 0) > 1
}
